<template>
    <div class="form-container">
        <h2 style="margin: 0 0 16px 0; color: var(--color-ds-primary);">Create Scenario Item</h2>
        <div class="form-section">
            <div class="form-group">
                <label>Action Name</label>
                <input type="text" placeholder="create scenario item" v-model="actionName" />
            </div>
            <div class="form-group">
                <label>Item Name</label>
                <input type="text" placeholder="e.g. New Product Line" v-model="itemName" />
            </div>
            <div class="form-group">
                <label>Item Description</label>
                <input type="text" placeholder="e.g. Add new product distribution" v-model="itemDescription" />
            </div>
            <div class="form-group">
                <label>Table Name</label>
                <select v-model="selectedTable">
                    <option value="">Select Table</option>
                    <option v-for="table in tables" :key="table.name" :value="table.name">
                        {{ table.name }}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label>Action</label>
                <textarea
                    v-model="action"
                    placeholder="Enter action details..."
                    rows="4"
                ></textarea>
            </div>
            <div class="form-group">
                <label>Condition</label>
                <textarea
                    v-model="condition"
                    placeholder="Enter condition details..."
                    rows="4"
                ></textarea>
            </div>
            <div class="form-group">
                <label>Scenario Name</label>
                <select v-model="scenarioName">
                    <option value="">Select Scenario</option>
                    <option v-for="scenario in scenarios" :key="scenario" :value="scenario">
                        {{ scenario }}
                    </option>
                </select>
            </div>
            <button class="button button-full" @click="addWorkflowItem">Add Workflow Item</button>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps } from 'vue';
import { addWorkflowItem as addWorkflowItemUtil, createScenarioItemWorkflowItem } from '../utils/workflowUtils';
import { useTableSelection } from '../composables/useTableSelection';
import { useScenarioSelection } from '../composables/useScenarioSelection';

const props = defineProps({
    selectedModel: Object,
    models: Array
});

// Use composable for table selection logic
const { selectedTable, tables } = useTableSelection(props);

// Use composable for scenario selection logic
const { scenarios } = useScenarioSelection();

const actionName = ref('');
const itemName = ref('');
const itemDescription = ref('');
const action = ref('');
const condition = ref('');
const scenarioName = ref('');

const addWorkflowItem = async () => {
    // Create the workflow item data
    const { keys, values } = createScenarioItemWorkflowItem(
        actionName.value,
        itemName.value,
        itemDescription.value,
        selectedTable.value,
        action.value,
        condition.value,
        scenarioName.value
    );

    // Add to workflow sheet using utility
    await addWorkflowItemUtil(keys, values);
};
</script>
